import {useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {readSheet} from "read-excel-file/browser";
import axiApi from "ApiCaller";
import {SwalAlertClass} from "core/swalClass";

const COLUMN_ORDER = 0;
const COLUMN_UID = 1;

const readExcelUids = async (file) => {
    const rows = await readSheet(file);
    const ordered = rows.slice(1)
        .map((row) => ({
            order: Number(row[COLUMN_ORDER]),
            uid: String(row[COLUMN_UID] ?? "").trim(),
        }))
        .filter((row) => row.uid)
        .sort((a, b) => (a.order - b.order) || 0);
    return [...new Set(ordered.map((row) => row.uid))];
};

const fetchIslands = (uids, filtering) => {
    let params = {}, key;
    for (key in filtering) {
        let val = filtering[key];
        params[key] = Array.isArray(val) ? val[0] : val;
    }
    return axiApi.post("/api/assets/islands/with-assets/by-uid/", {...params, uids}).then((resp) =>
        resp.data.items.map((island) => ({...island, _totalAssets: island.assets.length}))
    );
};

const indexAssetsByUid = (islands) => {
    const byUid = {};
    islands.forEach((island) => {
        island.assets.forEach((asset) => {
            byUid[asset.uid] = {asset, island};
        });
    });
    return byUid;
};

const buildChosenAsset = (asset, island) => ({
    ...asset,
    _parentIslandId: island.id,
    _parentIslandName: island.name,
    _parentZoneName: island.zone_name || "",
    _parentTotalAssets: island._totalAssets,
});

const ImportAssetsExcel = ({filtering = {}, onImport}) => {
    const input = useRef(null);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

    const onChange = async (e) => {
        const file = e.target.files[0];
        e.target.value = "";
        if (!file) return;
        if (!file.name.toLowerCase().endsWith(".xlsx")) {
            Alert.warning("Excel", "El archivo debe ser un Excel (.xlsx).");
            return;
        }
        let uids;
        try {
            uids = await readExcelUids(file);
        } catch (error) {
            Alert.warning("Excel", "No se ha podido leer el Excel.");
            return;
        }
        if (!uids.length) {
            Alert.warning("Excel", "El Excel no contiene UID.");
            return;
        }
        let islands;
        try {
            islands = await fetchIslands(uids, filtering);
        } catch (error) {
            Alert.warning("Excel", "No se han podido cargar los contenedores.");
            return;
        }
        const byUid = indexAssetsByUid(islands);
        const found = uids.filter((uid) => byUid[uid]);
        const missing = uids.filter((uid) => !byUid[uid]);
        if (!found.length) {
            Alert.warning("Excel", "Ningún UID del Excel se ha encontrado.");
            return;
        }
        onImport({
            islands,
            chosen: found.map((uid) => buildChosenAsset(byUid[uid].asset, byUid[uid].island)),
        });
        if (missing.length) {
            Alert.warning("Excel", `${missing.length} UID no encontrados: ${missing.join(", ")}`);
        }
    };

    return (
        <>
            <input type="file" accept=".xlsx" hidden ref={input} onChange={onChange} />
            <button
                type="button"
                className="btn btn-outline-secondary mt-4"
                title="Selecciona los contenedores en el orden del Excel"
                onClick={() => input.current.click()}>
                <FontAwesomeIcon icon="fa-solid fa-file-excel" /> Importar Excel
            </button>
        </>
    );
};

export default ImportAssetsExcel;
